import type { LinearFn2d, Point2d } from "."
import { whereDoLinesIntersect } from "./collision/whereDoLinesIntersect"
import { createNormalFnAnywhere } from "./createNormalFn"

export const findClosestPointOnLine_DEBUG = (
  point: Point2d,
  line: LinearFn2d,
): { result: Point2d; procedure: { line: LinearFn2d } } => {
  const normalFn = createNormalFnAnywhere(line, point)
  const intersection = isFinite(normalFn.slope)
    ? whereDoLinesIntersect(line, normalFn)
    : { x: point.x, y: line(point.x) }
  if (intersection) {
    return { result: intersection, procedure: { line: normalFn } }
  }
  throw new Error(`Unexpected result from getClosestPointOnLine`)
}

export const findClosestPointOnLine = (
  point: Point2d,
  line: LinearFn2d,
): Point2d => findClosestPointOnLine_DEBUG(point, line).result
